import React, { useState, useEffect } from "react";
import { IconButton, Zoom } from "@mui/material";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const ScrollToTopButton = () => {
    const [visible, setVisible] = useState(false);
    const [isClient, setIsClient] = useState(false);

    useEffect(() => {
        setIsClient(true); // Markiert, dass wir auf dem Client sind
        
        const toggleVisibility = () => {
            setVisible(window.scrollY > 300);
        };

        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // Auf dem Server nichts rendern, um Hydration-Fehler zu vermeiden
    if (!isClient) {
        return null;
    }

    return (
        <Zoom in={visible}>
            <IconButton
                onClick={scrollToTop}
                aria-label="Nach oben scrollen"
                sx={{
                    position: "fixed",
                    bottom: 20,
                    right: 20,
                    backgroundColor: "primary.main",
                    color: "white",
                    "&:hover": {
                        backgroundColor: "primary.dark",
                    },
                    boxShadow: 3,
                    zIndex: 1000
                }}
            >
                <KeyboardArrowUpIcon fontSize="large" />
            </IconButton>
        </Zoom>
    );
};

export default ScrollToTopButton;
